import { Aspect } from '@teambit/harmony';

export const SnappingAspect = Aspect.create({
  id: 'teambit.component/snapping',
});
